import {BillEventTypeEnum} from "./BillEvent";

export enum BillEventCategory {
	All = "All",
	Payments = "Payments",
	Notes = "Notes"
}

/**
 * Bill event type object model.
 */
export default class BillEventTypeObject {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to BillEventTypeObject.
	 * @param {string} string
	 * @return {BillEventTypeObject}
	 */
	public static fromString(string: string): BillEventTypeObject {
		return new BillEventTypeObject(string)
	}

	/**
	 * Get BillEventTypeObjects for given category.
	 * @param {string} filter Category key.
	 * @return {BillEventTypeObject[]} List of BillEventTypeObjects for given category.
	 */
	public static getTypesForCategory(filter: string): BillEventTypeObject[] {
		if (filter === BillEventCategory.All) {
			return BillEventTypeObject.getAllTypes();
		}
		if (filter === BillEventCategory.Payments) {
			return BillEventTypeObject.getPaymentTypes();
		}
		if (filter === BillEventCategory.Notes) {
			return BillEventTypeObject.getNoteTypes();
		}
		return null;
	}

	public static getAllTypes(): BillEventTypeObject[] {
		const result: BillEventTypeObject[] = [];
		for (let key in BillEventTypeEnum) {
			result.push(BillEventTypeObject.fromString(BillEventTypeEnum[key]));
		}
		return result;
	}

	public static getPaymentTypes(): BillEventTypeObject[] {
		return [
			BillEventTypeObject.fromString(BillEventTypeEnum.Payment),
			BillEventTypeObject.fromString(BillEventTypeEnum.BillPaid)
		];
	}

	public static getNoteTypes(): BillEventTypeObject[] {
		return [
			BillEventTypeObject.fromString(BillEventTypeEnum.Note)
		];
	}
}
